module.exports = __webpack_public_path__ + "img/温州市.2139bd36.png";